<template>
    <div>
        <vue-slick-carousel
            ref="c1"
            v-bind="c1Setting"
            @beforeChange="onBeforeChangeC2"
            v-if="images.length"
        >
            <div
                v-for="(img, index) in images"
                :key="index"
                class="slider slider__full"
                :style="{ backgroundImage: 'url(' + img.thumb + ')' }"
            ></div>
            <template #prevArrow="arrowOption">
                <div class="custom__arrow custom__arrow--left"></div>
            </template>
            <template #nextArrow="arrowOption">
                <div class="custom__arrow custom__arrow--right"></div>
            </template>
        </vue-slick-carousel>

        <vue-slick-carousel
            ref="c2"
            v-bind="c2Setting"
            @beforeChange="onBeforeChangeC1"
            v-if="images.length"
        >
            <div
                v-for="(img, index) in images"
                :key="index"
                class="slider slider__thumbnail"
            >
                <img
                    :src="img.thumb"
                    :alt="img.name"
                    class="slider__image"
                />
            </div>
            <template #prevArrow="">
                <div class="custom__arrow custom__arrow--left"></div>
            </template>
            <template #nextArrow="">
                <div class="custom__arrow custom__arrow--right"></div>
            </template>
        </vue-slick-carousel>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    props: ["prodid"],
    components: {
        "vue-slick-carousel": VueSlickCarousel
    },
    data() {
        return {
            c1Setting: {
                arrows: true,
                dots: false,
                asNavFor: this.$refs.c2,
                focusOnSelect: true
            },
            c2Setting: {
                arrows: true,
                dots: false,
                asNavFor: this.$refs.c1,
                focusOnSelect: true,
                slidesToShow: 4
            },
            images: []
        };
    },
    methods: {
        onBeforeChangeC1(currentPosition, nextPosition) {
            this.$refs.c1.goTo(nextPosition);
        },
        onBeforeChangeC2(currentPosition, nextPosition) {
            this.$refs.c2.goTo(nextPosition);
        },
        loadImages(id) {
            let that = this;
            axios
                .post("/get-product-images", {
                    id: id
                })
                .then(function(res) {
                    that.images = [...res.data];
                });
        }
    },
    mounted() {
        this.loadImages(this.prodid);
    }
};
</script>

<style scoped>
.slider {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 10px;
    padding: 5px;
}
.slider__image {
    width: auto;
    height: 100%;
    border-radius: 10px;
    margin: auto;
}

.slider__full {
    height: 15rem;
}
.slider__thumbnail {
    height: 4rem;
    border: 1px solid transparent;
}
.slider__thumbnail:hover {
    border: 1px solid #000;
}
.custom__arrow {
    width: 30px;
    height: 30px;
    background: #5e5e5d;
    position: absolute;
    z-index: 9;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.custom__arrow--left {
    left: 15px;
}
.custom__arrow--left::before {
    font-family: "whatswhat";
    content: "\e914";
}
.custom__arrow--right {
    right: 15px;
}
.custom__arrow--right::before {
    font-family: "whatswhat";
    content: "\e913";
}

.slick-slide {
    margin: 0 5px;
}

.slick-list {
    margin: 0 -5px;
}
.slick-slider {
    overflow: hidden;
}
</style>
